import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        form: {
            maxWidth:"100%",
            marginTop: theme.spacing(5),
            marginBottom: theme.spacing(10),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent:'center',
            margin:"auto",
        },

    }));